module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotDetails) ? _c('b-modal', {
    ref: "missionSlotEditModal",
    attrs: {
      "id": "missionSlotEditModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.slot.edit'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionSlotEditData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.editMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotEditTitleState,
      "feedback": _vm.missionSlotEditTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotEditData.title),
      callback: function($$v) {
        _vm.missionSlotEditData.title = $$v
      },
      expression: "missionSlotEditData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotEditData.description),
      callback: function($$v) {
        _vm.missionSlotEditData.description = $$v
      },
      expression: "missionSlotEditData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotEditDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotEditData.difficulty),
      callback: function($$v) {
        _vm.missionSlotEditData.difficulty = $$v
      },
      expression: "missionSlotEditData.difficulty"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.externalAssignee.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.externalAssignee.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.missionSlotDetails.assignee !== null
    },
    model: {
      value: (_vm.missionSlotEditData.externalAssignee),
      callback: function($$v) {
        _vm.missionSlotEditData.externalAssignee = $$v
      },
      expression: "missionSlotEditData.externalAssignee"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.restricted),
      callback: function($$v) {
        _vm.missionSlotEditData.restricted = $$v
      },
      expression: "missionSlotEditData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.reserve),
      callback: function($$v) {
        _vm.missionSlotEditData.reserve = $$v
      },
      expression: "missionSlotEditData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.blocked),
      callback: function($$v) {
        _vm.missionSlotEditData.blocked = $$v
      },
      expression: "missionSlotEditData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotEditData.autoAssignable = $$v
      },
      expression: "missionSlotEditData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotEditData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotEditRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected,
      "initialValue": _vm.restrictedSlotTypeaheadInitialValue
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotEditDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotEditDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotEditData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotEditData.detailedDescription = $$v
      },
      expression: "missionSlotEditData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.aow = $$v
      },
      expression: "missionSlotEditRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.apex = $$v
      },
      expression: "missionSlotEditRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.contact = $$v
      },
      expression: "missionSlotEditRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.csla = $$v
      },
      expression: "missionSlotEditRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.gm = $$v
      },
      expression: "missionSlotEditRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.helicopters = $$v
      },
      expression: "missionSlotEditRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.jets = $$v
      },
      expression: "missionSlotEditRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.karts = $$v
      },
      expression: "missionSlotEditRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionSlotEditRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.marksmen = $$v
      },
      expression: "missionSlotEditRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.tacops = $$v
      },
      expression: "missionSlotEditRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.tanks = $$v
      },
      expression: "missionSlotEditRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotEditRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionSlotEditRequiredDLCs.vn = $$v
      },
      expression: "missionSlotEditRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.moveAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.moveAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotEditMoveAfterOptions
    },
    model: {
      value: (_vm.missionSlotEditMoveAfter),
      callback: function($$v) {
        _vm.missionSlotEditMoveAfter = $$v
      },
      expression: "missionSlotEditMoveAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot edit actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.editMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotEditModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbbfd5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotEditModal.vue
// module id = 514
// module chunks = 0